import { makeAutoObservable } from 'mobx';
import mcpStore from '@/store/chat/mcpStore';

class ConnectionLineStore {
  constructor() {
    this.startPoint = null;
    this.endPoint = null;
    this.points = null;
    this.containerWidth = 100;
    makeAutoObservable(this);
    // 差值, 判断当前页面的path是否是share/mcp,如果是diffY=64,否则diffY=0
    this.diffY = location.pathname.includes('/share/mcp') ? 30 : 40;
    this.minStartY = location.pathname.includes('/share/mcp') ? 0 : 0; // y轴最小坐标
    this.minEndY = 0; // y轴最小坐标
  }

  resetPoint(){
    this.startPoint = null;
    this.endPoint = null;
    this.containerWidth = 100;
  }

  updatePoint(id) {
    // 左侧容器
    const leftContainer = document.querySelector('#message-list');
    // 左侧容器中被点击选中的节点
    const currentLeftDom = leftContainer?.querySelector?.(`[data-id="${id}"]`);
    const rightContainer = document.querySelector('#vncviewer');
    // 右侧容器中被选中的节点
    const currentRightDom = rightContainer?.querySelector?.(`[data-id="card_${id}"]`);
    if(!currentRightDom){
      this.resetPoint();
      return;
    }

    
    // 圆圈半径
    const circleDiameter = 20;
    // 获取左侧的节点坐标、 右侧选中节点的坐标
    const { right }  = leftContainer.querySelector('.message-item-content')?.getBoundingClientRect() || {};
    let { top: startTop, width: leftWidth, height: leftHeight } = currentLeftDom?.getBoundingClientRect() || {};
    const { top: endTop, left, width: rightWidth, height: rightHeight } = currentRightDom?.getBoundingClientRect() || {};
    
    // 如果左侧节点被折叠起来, 宽高为0, 则获取左侧容器父节点的宽度或高度
    if(!leftWidth || !leftHeight) {
      const currentLeftDomParentNode = document.querySelector('#mcp-tools-active')?.getBoundingClientRect() || {};
      
      leftWidth = currentLeftDomParentNode.width;
      leftHeight = currentLeftDomParentNode.height;
      startTop = currentLeftDomParentNode.top;
    }
    
    if(!leftHeight || !rightHeight || !leftWidth || !rightWidth) {
      this.startPoint = null;
      this.endPoint = null;
      this.containerWidth = 100;
      return;
    };
    
    // svg宽度为两侧间距 + 圆圈直径
    const spacingWidth = left - right + circleDiameter * 2;
    // 圆圈的y轴坐标: 最小值顶部header的距离, 最大值为窗口高度+圆圈直径
    const startY = Math.min(Math.max(startTop + leftHeight/2, this.minStartY), window.innerHeight + circleDiameter) - this.diffY - 35;
    const endY = Math.min(Math.max(endTop - this.diffY, this.minEndY), window.innerHeight + circleDiameter);
    this.startPoint = { x: circleDiameter, y: startY };
    this.endPoint = { x: spacingWidth-circleDiameter, y: endY };
    this.containerWidth = spacingWidth;
  }
}

const connectionLineStore = new ConnectionLineStore();

export default connectionLineStore;
